'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/OTIT.png'


const SkylineMain = () => {
    // State to hold dynamic content
    const [serviceDetails] = useState({
        title: "OT, IoT Security for every context",
        text1: "Certainly! Securing OT (Operational Technology) and IoT (Internet of Things) devices is crucial due to their integration into critical infrastructures and everyday objects. Here are some content ideas and basic steps to help you create informative material on OT and IoT security:",
        image1: ServiceDetailsImg,
        title2: "Techtotalers' OT and IoT security services help protect critical infrastructure and connected devices in industrial and smart environments.",
        text2: (
            <>
                <b>Understanding OT and IoT Security:</b><br />
                Operational Technology (OT): Systems that control industrial operations.<br />
                Internet of Things (IoT): Networked devices that collect and exchange data.<br />
                <br />
                <b>Why is Security Crucial?:</b><br />
                Critical Infrastructure: Attacks on OT can disrupt essential services.<br />
                Data Privacy: IoT devices collect sensitive data vulnerable to breaches.<br />
                Operational Disruption: Cyberattacks can cause downtime and financial losses.<br />
                <br />
                <b>Security Best Practices:</b><br />
                Implement strong access controls and regular software updates.<br />
                Encrypt data transmitted between devices.<br />
                Segment OT and IoT networks to prevent unauthorized access.
            </>
        ),
        content3Title: "Elevating Excellence",
        text3: "Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for various types of roofs, such as shingle, tile, metal, and flat roofs. With their expertise, they ensure the longevity",
        text4: "Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for",
        features: [
            {
                icon: "icon-crane-1",
                title: "Reliable Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
            {
                icon: "icon-buildings",
                title: "Building Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
        ],
    });

    return (
        <React.Fragment>
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                  
                                </div>    
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                <h4 className="service-details__sidebar-title">Main Service</h4>
                                <ul className="service-details__service-list list-unstyled">
                                    <li>
                                    <Link to="/security-consulting">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Security Consulting
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/audit-&-compliance">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Audit & Compliance
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/cloud-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Cloud Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/network-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Network Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/design-&-implementation">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Design & Implementation
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/managed-it-services">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Managed IT Services
                                    </Link>
                                    </li>
                                    <li className="active">
                                    <Link to="/ot-iot-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        OT, IoT Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/api-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        API Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/offensive-security-red-teaming">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Offensive Security, Red Teaming
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/vulnerability-assessment">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Vulnerability Assessment
                                    </Link>
                                    </li>                               
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default SkylineMain;
